import { Currency } from '$api-client/types.gen'

export const getCurrencySymbol = (currency: string) => {
  switch (currency) {
    case Currency.GBP:
      return '£'
    case Currency.USD:
      return '$'
    case Currency.EUR:
      return '€'
    case Currency.CAD:
      return 'C$'
    case Currency.AUD:
      return 'A$'
    default:
      return currency
  }
}
